<template>
  <div class="cart-icon">
    <router-link :to="{ name: 'checkout' }">
      <CartSvg/>
    </router-link>
    <!--    <ul class="cart-products">-->
    <!--      <li v-for="(item, key) in cart">-->
    <!--        {{item.name}} - {{item.price}}-->
    <!--        <span class="remove"-->
    <!--              @click="removeItem(key)"-->
    <!--            >+</span>-->
    <!--      </li>-->
    <!--    </ul>-->
  </div>
</template>

<script>
import CartSvg from "./SVG/CartSvg";
import {mapGetters} from "vuex";

export default {
    name: 'ShoppingCart',

    components: {CartSvg},

    data: () => ({
        itemCounter: 0
    }),

    computed: {
        ...mapGetters(['cart'])
    },

    watch: {
        'cart': function () {
            this.build();
        }
    },
    created() {
        this.build()
    },


    methods: {
        build() {
            this.itemCounter = Object.keys(this.cart).length;
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ShoppingCart.vue